export default __webpack_public_path__ + "static/media/MW.16835008.ico";